import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { actions } from '@/redux/av-check';
import {
  CmsPageContentIdentifier,
  ReduxStateType,
  TariffOfferType,
  CmsPageContentType, FilterValuesType, FilterCriteriaType,
} from '@/types/av-check';

import {
  getTariffOffers,
  getAvailableContractDurations, getMatchedTariffOffers,
} from '@/utils';

import Item from './Item';

export interface StateProps {
  cmsContent: CmsPageContentType
  filterValues: FilterValuesType,
  tariffOffers: TariffOfferType[]
}

export interface DispatchProps {
  setCurrentContractDuration: Function
}

const ContractDurationSwitcher = ({
  cmsContent,
  filterValues,
  tariffOffers,
  setCurrentContractDuration,
} : StateProps & DispatchProps) => {
  const matchedTariffOffers = getMatchedTariffOffers(tariffOffers, {
    ...filterValues,
    [FilterCriteriaType.CONTRACT_DURATION]: undefined,
  });
  const availableContractDurations = getAvailableContractDurations(matchedTariffOffers);
  const containsDuration24 = availableContractDurations.indexOf(24) !== -1;
  const containsDuration1 = availableContractDurations.indexOf(1) !== -1;

  return (
    <div className="switcher content-switcher" key={`${filterValues.CONTRACT_DURATION}_${containsDuration24}_${containsDuration1}`}>
      <div className="section-switcher-text" dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.ContractDurationSwitcherLabel] }} />
      <div className="switcher-box">
        <Item
          id="duration24"
          label={cmsContent[CmsPageContentIdentifier.ContractDuration24Month]}
          checked={filterValues.CONTRACT_DURATION === 24}
          onSelect={() => setCurrentContractDuration(24)}
          disabled={!containsDuration24}
        />
        <Item
          id="duration1"
          label={cmsContent[CmsPageContentIdentifier.ContractDuration1Month]}
          checked={filterValues.CONTRACT_DURATION === 1}
          onSelect={() => setCurrentContractDuration(1)}
          disabled={!containsDuration1}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: ReduxStateType) => ({
  cmsContent: state.cmsContent,
  tariffOffers: getTariffOffers(state.result),
  filterValues: state.filterValues,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setCurrentContractDuration:
    (contractDuration: number) => dispatch(actions.setCurrentContractDuration(contractDuration)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContractDurationSwitcher);
